<template>
  <div>
    <list-widget :items="landlords.items" routeName="landlord" :hideHeader="true" :changeRoute="true" :addNewTitle="$t('top_bar.add_new_landlord')" addNewRouteName="add-landlord">
      <template slot="item-template" slot-scope="props">
        <ListItemTemplate :item="props.item"></ListItemTemplate>
      </template>
    </list-widget>
    <div class="list-widget__footer items-container__footer" v-if="landlords.items">
      <slot name="footer"><a class="link" v-on:click.stop.prevent="extendLimit()" v-if="landlords.items && landlords.total > landlords.items.length">{{ $t('common.load_more') }}</a></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import ListWidget from 'common/ListWidget';
import ListItemTemplate from './ListItemTemplate';

export default {
  components: {
    ListWidget,
    ListItemTemplate,
  },
  computed: mapGetters({
    landlordsLimit: 'landlord/landlords/limit',
    landlords: 'landlord/landlords/landlords',
    user: 'user/user/user',
  }),
  created() {
    this.$store.commit(`landlord/landlords/${mTypes.SET_LIMIT}`, 10);
    this.fetchLandlords();
  },
  methods: {
    fetchLandlords() {
      this.$store.dispatch('landlord/landlords/fetch', { keyword: this.$route.query.keyword, user: this.user }).then(() => {
        if (this.landlords.total === 0) {
          this.$router.push({ name: 'add-landlord' });
        }
      });
    },
    extendLimit() {
      this.$store.commit(`landlord/landlords/${mTypes.SET_LIMIT}`, this.landlordsLimit + 10);
    },
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/landlords/Sidebar.vue